const STORAGE_KEY = 'stale-chunk-reload';
/** A second failure this soon after reloading is a real error, not an old tab: let it surface instead of looping. */
const RELOAD_GUARD_MS = 10_000;

const readLastReload = (): number => {
  try {
    return Number(sessionStorage.getItem(STORAGE_KEY) ?? 0);
  } catch {
    return 0;
  }
};

const rememberReload = (): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    // Without storage the guard can't work; reloading once is still better than a broken page.
  }
};

/**
 * A tab opened before a release still asks for the previous build's chunks (a page, a blog article, the
 * SEO texts …), which the new build no longer has. Vite reports any failed dynamic import as
 * `vite:preloadError`; reloading fetches the new index.html with the current chunk names. Route
 * components get the same treatment from TanStack Router's lazyRouteComponent.
 */
export function reloadOnStaleChunk(): void {
  window.addEventListener('vite:preloadError', (event) => {
    if (Date.now() - readLastReload() < RELOAD_GUARD_MS) {
      return;
    }
    rememberReload();
    event.preventDefault();
    window.location.reload();
  });
}
